export const HOST = "";
export const HOSTAPI = "192.168.100.41:3031";

// export const HOST = "http://localhost:3009";
// export const HOSTAPI = "http://localhost:3009";
